import React from "react"

type Props = {
  id: string
  children: React.ReactNode
}

const ReferenceList = ({ id, children }: Props) => {
  return (
    <span
      id={id}
      className="pt-2 font-raleway-medium font-light text-justify text-[8px] leading-[8px]"
    >
      <br /> {children}
    </span>
  )
}

export default ReferenceList
